// extracted by mini-css-extract-plugin
export var cartContainer = "_js-4";
export var gray = "_js-1";
export var itemContainer = "_js-2";
export var itemDetails = "_js-3";
export var strong = "_js-0";